import { render, staticRenderFns } from "./GalleryBlockGrid.vue?vue&type=template&id=de8f5692"
import script from "./GalleryBlockGrid.vue?vue&type=script&lang=ts"
export * from "./GalleryBlockGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports